import React from "react";
import find from "lodash/find";
import moment from "moment";
import Add from "../parts/modals/add-to-calendar";

function View(props, { locals }) {
  const { cycle, wholeCycle, disableClose } = props;
  return (
    <div id="login-wrapper">
      <Add cycle={cycle} wholeCycle={wholeCycle} disableClose={disableClose} />
    </div>
  );
}

const AddToCalendar = (app) => {
  app.get("*", async ({ req, res, load, locals }) => {
    const { cycleId, wholeCycle } = req.query;

    if (!cycleId) {
      res.status = 404;
      return next();
    }

    await Promise.all([
      load("activeExercises", {
        start: moment().subtract(6, "month"),
        end: moment().add(1, "year"),
      }),
      load("editCycle", { cycle: req.query.cycleId }),
      load("libraryCycles"),
    ]);

    const cycle = locals.editCycle
      ? locals.editCycle
      : find(locals.libraryCycles, { _id: req.query.cycleId });

    res.body = (
      <View
        cycle={cycle}
        wholeCycle={wholeCycle || false}
        disableClose={true}
      />
    );
  });
};

export default AddToCalendar;
